import React, { useState, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as actionTypes from "../../../../store/actions/actionTypes";
import { openAPI } from "../../../../config";
const AddYourCompany = lazy(() => import("../../Popups/AddYourCompany"));
const ClaimYourProfile = lazy(() => import("../../Popups/ClaimProfile"));
const VerifyYourProfile = lazy(() => import("../../Popups/VerifyProfile"));
const EnterpriseLogin = lazy(() => import("../../Popups/EnterpriseLogin"));

const FooterContainer = (props) => {
  const [isAddCompany, setAddCompany] = useState(false);
  const [isClaimProfile, setClaimProfile] = useState(false);
  const [isVerifyProfile, setVerifyProfile] = useState(false);
  const [isEnterprise, setEnterprise] = useState(false);

  const setCompanyPopUpFalse = () => {
    setAddCompany(false);
  };

  const setClaimProfilePopUpFalse = () => {
    setClaimProfile(false);
  };

  const setVerifyProfilePopUpFalse = () => {
    setVerifyProfile(false);
  };

  const setEnterprisePopUpFalse = () => {
    setEnterprise(false);
  };

  return (
    <React.Fragment>
      <section class="footer">
        <div class="container">
          <div class="footerTxt">
            <img src="/images/logo_white.webp" alt="" width={175} height={48} />
            <span class="txt">{`FeaturedCustomers has ${Number(
              props.totalReviewCount
            ).toLocaleString()}+ validated customer references
            including reviews, case studies, success stories, customer stories,
            testimonials and customer videos that will help you make better
            software purchasing decisions.`}</span>
          </div>
          <div class="footerNav">
            <ul>
              <li>
                Browse by
                <ul>
                  <li>
                    <Link to={`/software`}>Software Categories</Link>
                  </li>
                  <li>
                    <Link to={`/services`}>Services Categories</Link>
                  </li>
                  <li>
                    <Link to={`/vendors`}>Vendor Directory</Link>
                  </li>
                  {/* <li>
                    <Link to={`/customers`}>Customer Directory</Link>
                  </li> */}
                </ul>
              </li>
              <li>
                FeaturedCustomers
                <ul>
                  <li>
                    <Link to={`/about-us`}>About</Link>
                  </li>
                  <li>
                    <Link to={`/terms`}>Terms</Link>
                  </li>
                  <li>
                    <Link to={`/privacy`}>Privacy</Link>
                  </li>
                  <li>
                    <Link to={`/contact-us`}>Contact</Link>
                  </li>
                  <li>
                    <Link to={`/do-not-sell`}>
                      Do Not Sell My Personal Information
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                Connect
                <ul>
                  <li>
                    <Link to={`/press-releases`}>Press Releases</Link>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/featuredcustomers-com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/FeaturedCust"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/featuredcustomers"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                For Vendors
                <ul>
                  <li
                    onClick={(e) => {
                      e.preventDefault();
                      setClaimProfile(true);
                    }}
                  >
                    <a href="#Upgrade Your Profile">Upgrade Your Profile</a>
                  </li>
                  <li
                    onClick={(e) => {
                      e.preventDefault();
                      setVerifyProfile(true);
                    }}
                  >
                    <a href={"#Verify Your Profile"}>Verify Your Profile</a>
                  </li>
                  <li
                    onClick={(e) => {
                      e.preventDefault();
                      setAddCompany(true);
                    }}
                  >
                    <a href={"#Add Your Company"}>Add Your Company</a>
                  </li>
                  <li
                    onClick={(e) => {
                      e.preventDefault();
                      if (props.isEnterprise) {
                        //logout
                        openAPI
                          .get(
                            `${process.env.REACT_APP_API_URL}/enterprise/logout`,
                            {
                              withCredentials: true,
                            }
                          )
                          .then((response) => {
                            if (response.data.status === 200) {
                              props.setEnterpriseLogout();
                              props.history.push("/");
                            }
                          })
                          .catch((error) => {});
                      } else {
                        setEnterprise(true);
                      }
                    }}
                  >
                    <a href="#Enterprise Login" className="open-overlay">
                      {props.isEnterprise
                        ? `Enterprise Logout`
                        : `Enterprise Login`}
                    </a>
                  </li>
                  <li class="btn_software_recommended">
                    <Link to="/get-free-advice">
                      Get free software recommendations
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/** Here */}

      {isAddCompany ? (
        <Suspense fallback={<></>}>
          <AddYourCompany setCompanyPopUpFalse={setCompanyPopUpFalse} />
        </Suspense>
      ) : null}
      {isClaimProfile ? (
        <Suspense fallback={<></>}>
          <ClaimYourProfile
            setClaimProfilePopUpFalse={setClaimProfilePopUpFalse}
          />
        </Suspense>
      ) : null}
      {isVerifyProfile ? (
        <Suspense fallback={<></>}>
          <VerifyYourProfile
            setVerifyProfilePopUpFalse={setVerifyProfilePopUpFalse}
          />
        </Suspense>
      ) : null}
      {isEnterprise ? (
        <Suspense fallback={<></>}>
          <EnterpriseLogin setEnterprisePopUpFalse={setEnterprisePopUpFalse} />
        </Suspense>
      ) : null}
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    totalReviewCount: state.webSiteCommonData.common_count.total_reviews_count,
    popupState: state.popupState,
    isEnterprise: state.homePage.isEnterpriseLogin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setClaimProfileToTrue: () =>
      dispatch({ type: actionTypes.UPDATE_CLAIM_PROFILE_TRUE }),
    setEnterpriseLogout: () =>
      dispatch({ type: actionTypes.ENTRERPRISE_LOGOUT }),
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(withRouter(FooterContainer));
